import { mountStoreDevtool } from 'simple-zustand-devtools';
import { create } from 'zustand';

import { NearByV4Response, OfficeSearchApiResponse, SlotsSearchResponseV4 } from '@src/lib/__generated/api';

export type PSFacilityRescheduling = OfficeSearchApiResponse | NearByV4Response;
export type PSSlotRescheduling = SlotsSearchResponseV4;
export type PSNearbyFacilityRescheduling = NearByV4Response;

export type State = {
	// current facility for searching for timeslots for rescheduling
	facility: PSFacilityRescheduling | null;
	facilityLocation: { longitude: number; latitude: number } | null;
	nearbyFacilities: PSNearbyFacilityRescheduling[] | null;
	// chosen facility for rescheduling, can be a nearby facility (after clicking on a timeslot)
	selectedFacility: PSFacilityRescheduling | null;
	timeslot: PSSlotRescheduling | null;
	isReschedulingInfoFetching: boolean;
};

type Actions = {
	setFacility: (facility: PSFacilityRescheduling | null) => void;
	setFacilityLocation: (facilityLocation: { longitude: number; latitude: number }) => void;
	setNearbyFacilities: (facility: PSNearbyFacilityRescheduling[] | null) => void;
	setSelectedFacility: (selectedFacility: PSFacilityRescheduling | null) => void;
	setTimeslot: (timeslot: PSSlotRescheduling | null) => void;
	setIsReschedulingInfoFetching: (isReschedulingFetching: boolean) => void;
	reset: () => void;
};

const initialState: State = {
	facility: null,
	facilityLocation: null,
	nearbyFacilities: [],
	selectedFacility: null,
	timeslot: null,
	isReschedulingInfoFetching: false,
};

const useReschedulingStorePS = create<State & Actions>((set) => ({
	...initialState,
	setFacility: (facility) => set({ facility }),
	setFacilityLocation: (facilityLocation) => set({ facilityLocation }),
	setNearbyFacilities: (nearbyFacilities) => set({ nearbyFacilities }),
	setSelectedFacility: (selectedFacility) => set({ selectedFacility }),
	setTimeslot: (timeslot) => set({ timeslot }),
	setIsReschedulingInfoFetching: (isReschedulingInfoFetching) => set({ isReschedulingInfoFetching }),
	reset: () => {
		set(initialState);
	},
}));

if (process.env.NODE_ENV === 'development') {
	mountStoreDevtool('useReschedulingStorePS', useReschedulingStorePS);
}

export default useReschedulingStorePS;
